<template>
    <div style="position:relative;height:100%;">
     <div style="width:100%;height:30px;font-weight:bold;">
       <BaseIcon icon="md-apps" style="margin-right:5px" />通知公告 </div>


       <div class="flex-wrap" style="height:calc(100% - 30px);align-items:stretch;background:var(--bg3);border-radius:5px;padding:25px 10px;">

        <Timeline style="width:100%;">
            <template v-for="item in items">
                <TimelineItem :key="item.id">
                <div class="flex-wrap flex-between" style="position:relative;top:-5px;" >
                   <div> <span  style="color:var(--primary);font-weight:bold;">{{ item.name }} </span><img v-if="item.new" src="https://nbgz-pmis-1257839135.cos.ap-shanghai.myqcloud.com/beauty/new.gif" style="display:inline;width:25px;height:12px;margin-left:5px;" />
                    <div style="font-size:12px;">{{item.desc}}</div>
                   </div>
                   <div style="font-size:13px;color:var(--success);text-align:center;font-weight:bold;margin-right:10px;">{{ item.date }}</div>
                </div>
            </TimelineItem>
            </template>
        </Timeline>
      </div>
     </div>

 </template>

<script>
export default {
  data() {
    return {
      items: [{
        name: '合同审核标准变更',
        node: '事业部审核',
        desc: '合同审核标准变更',
        date: '05/10',
        state: '草稿',
        new: true,
      }, {
        name: '五一放假通知',
        date: '04/30',
        desc: '合同管理系统放假期间正常运行',
        state: '履约中',
        new: true,
      }, {
        name: '合同管理系统上线',
        date: '04/27',
        desc: '请大家试用新上线的合同管理系统',
        state: '付款中',
      }],
    };
  },
};
</script>

 <style>

 </style>
